// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalOverlay_root__3CZaW"};